import { Form } from 'components/form'
import { useAlert } from 'contexts/alert'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { useHistory, useParams } from 'react-router-dom'
import api from 'services/api'

import { ajvResolver } from '@hookform/resolvers/ajv'
import EmailLogSchema, { IEmailLogFormData } from 'schema/operation/email-log'
import { useStyles } from './styles'
interface IRouteParams {
  id: string
}

const EmailLogForm: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [readonly, setReadonly] = useState(false)

  const { closeAlert, openAlert } = useAlert()
  const params = useParams<IRouteParams>()
  const firstInputElement = useRef(null)
  const classes = useStyles()
  const history = useHistory()

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    control,
    setFocus,
  } = useForm<IEmailLogFormData>({
    resolver: ajvResolver(EmailLogSchema),
    defaultValues: {
      emailSentTo: '',
      title: '',
      emailSentAt: '',
    },
  })

  const handleChange = (formField: any) => closeAlert()

  // main data load

  useEffect(() => {
    async function loadData() {
      const { id } = params

      // form data
      await api
        .get(`/email-logs/${id}`)
        .then((response) => {
          const { data } = response.data

          const emailLogResult = {
            id: data.id,
            emailSentTo: data.emailSentTo,
            title: data.title,
            emailSentAt: data.emailSentAt,
            body: data.body,
          }

          return emailLogResult
        })
        .then((emailLogResult: IEmailLogFormData) => {
          reset(emailLogResult)
        })
        .catch((error) => {
          console.log(error)
          return error
        })
    }

    if (params.id) {
      loadData()
      setReadonly(true)
    }
  }, [params, params.id])

  // data save
  const onSubmit: SubmitHandler<IEmailLogFormData> = useCallback(async (data) => {
    setIsLoading(true)

    const payLoad: IEmailLogFormData = {
      id: '',
      emailSentTo: data.emailSentTo,
      title: data.title,
      emailSentAt: data.emailSentAt,
      body: data.body,
    }

    if (params.id) {
      const { id } = params

      payLoad.id = id

      await api
        .put(`/email-logs`, payLoad)
        .then(() => {
          openAlert('Cliente atualizado com sucesso!', 'success')
          history.push('/email-logs')
        })
        .catch((error) => {
          openAlert(error?.response?.data?.data?.message ?? 'Ops! Algo inesperado aconteceu!', 'error')
        })
        .finally(() => setIsLoading(false))
    } else {
      await api
        .post('/email-logs', payLoad)
        .then(() => {
          reset()
          openAlert('Dado cadastrado com sucesso!', 'success')
          reset()
        })
        .catch((error) => {
          openAlert(error?.response?.data?.data?.message ?? 'Ops! Algo inesperado aconteceu!', 'error')
        })
        .finally(() => setIsLoading(false))
    }
  }, [])

  useEffect(() => {
    // setFocus(firstInputElement)
  }, [setFocus])

  return (
    <Form.Root onHandleSubmit={handleSubmit(onSubmit)}>
      <Form.Info
        title='Log de E-Mails'
        subTitle='Dados sobre os logs dos e-mails enviados pela plataforma.'
      />

      <Form.Body>
        <Form.Input
          label='E-Mail enviado ao'
          error={!!errors.emailSentTo}
          errorMessage={errors?.emailSentTo?.message}
          disabled={isLoading || readonly}
          sizing={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          maxLength={100}
          name='emailSentTo'
          rules={{ onChange: (e) => handleChange(e) }}
          register={register}
        />

        <Form.Input
          label='Título'
          error={!!errors.title}
          errorMessage={errors?.title?.message}
          disabled={isLoading || readonly}
          sizing={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          maxLength={100}
          name='title'
          rules={{ onChange: (e) => handleChange(e) }}
          register={register}
        />

        <Form.Input
          label='E-mail enviado em'
          error={!!errors.emailSentAt}
          errorMessage={errors?.emailSentAt?.message}
          disabled={isLoading || readonly}
          sizing={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          maxLength={10}
          name='emailSentAt'
          rules={{ onChange: (e) => handleChange(e) }}
          register={register}
          type='date'
        />

        <Form.Input
          label='Corpo'
          error={!!errors.body}
          errorMessage={errors?.body?.message}
          disabled={isLoading || readonly}
          sizing={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          maxLength={1024}
          name='body'
          rules={{ onChange: (e) => handleChange(e) }}
          register={register}
        />
      </Form.Body>

      <Form.Divisor />

      <Form.Footer>
        <Form.Button
          label='SALVAR'
          type='submit'
          variant='contained'
          isLoading={isLoading}
        />
        <Form.Button
          label='CANCELAR'
          type='cancel'
          variant='text'
          isLoading={isLoading}
        />
      </Form.Footer>
    </Form.Root>
  )
}

export default EmailLogForm
